module.exports = __webpack_public_path__ + "static/media/014-chat.c2602f96.svg";